import React, { Component, Fragment } from 'react';
import "./index.scss";
import { Toast } from './Toast';

const debugData = makeDebugData();

const chargeState = new Map([
    [0, 'START'],
    [1, 'NIGHT CHECK'],
    [2, 'DISCONNECT'],
    [3, 'NIGHT'],
    [4, 'FAULT'],
    [5, 'BULK CHARGE'],
    [6, 'ABSORPTION'],
    [7, 'FLOAT'],
    [8, 'EQUALIZE'],
]);

const arrayFault = [
    'overcurrent',
    'FETs shorted',
    'software bug',
    'battery HVD',
    'array HVD',
    'EEPROM setting edit (reset required)',
    'RTS shorted',
    'RTS was valid, now disconnected',
    'local temperature sensor failed',
    'fault 11',
    'fault 12',
    'fault 13',
    'fault 14',
    'fault 15',
    'fault 16',
];

const loadState = new Map([
    [0, 'START'],
    [1, 'LOAD ON'],
    [2, 'LVD_WARNING'],
    [3, 'LVD'],
    [4, 'FAULT'],
    [5, 'DISCONNECT']
]);

const loadFault = [
    'external short circuit',
    'overcurrent',
    'FETs shorted',
    'software bug',
    'HVD',
    'heatsink over-temperature',
    'EEPROM setting edit (restart required)',
    'fault 8'
]

const alarmBits = [
    "ALARM",
    "RTS open",
    "RTS shorted",
    "RTS disconnected",
    "Ths open",
    "Ths shorted",
    "SSMPPT hot",
    "Current limit",
    "Current offset",
    "Undefined",
    "Undefined",
    "Uncalibrated",
    "RTS miswire",
    "Undefined",
    "Undefined",
    "miswire",
    "FET open",
    "P12",
    "High Va current limit",
    "Alarm 19",
    "Alarm 20",
    "Alarm 21",
    "Alarm 22",
    "Alarm 23",
    "Alarm 24" 
];

const dipSwitch = [
    'battery type (0=user select jumper, 1=custom battery settings)',
    'LVD-LVR (0=11.5V / 12.6V, 1=custom load settings)',
    'Equalize (1=enabled if battery type has EQ)',
    'Comm. Select (0=meterbus, 1=modbus)'
];

const ledState = new Map([
    [ 0, 'LED_START' ],
    [ 1, 'LED_START2' ],
    [ 2, 'LED_BRANCH' ],
    [ 3, 'EQUALIZE (fast green blink)' ],
    [ 4, 'FLOAT (slow green blink)' ],
    [ 5, 'ABSORPTION (green blink 1Hz)' ],
    [ 6, 'GREEN_LED' ],
    [ 7, 'UNDEFINED' ],
    [ 8, 'YELLOW_LED' ],
    [ 9, 'UNDEFINED' ],
    [ 10, 'BLINK_RED_LED' ],
    [ 11, 'RED_LED' ],
    [ 12, 'R-Y-G ERROR' ],
    [ 13, 'R/Y-G ERROR' ],
    [ 14, 'R/G-Y ERROR' ],
    [ 15, 'R-Y ERROR (HTD)' ],
    [ 16, 'R-G ERROR (HVD)' ],
    [ 17, 'R/Y-G/Y ERROR' ],
    [ 18, 'G/Y/R ERROR' ],
    [ 19, 'G/Y/R x 2' ],
]);

const parameters = [
    [ 0x0008, "Battery Voltage", "V", 100*2**-15 ],
    [ 0x0009, "Array Voltage", "V", 100*2**-15 ],
    [ 0x000a, "Load voltage", "V", 100*2**-15 ],
    [ 0x000b, "Charging current", "A", 79.16*2**-15 ],
    [ 0x000c, "Load current", "A", 79.16*2**-15 ],
    [ 0x000d, "Heatsink temperature", "ºC", 1 ],
    [ 0x000e, "Battery temperature", "ºC", 1 ],
    [ 0x000f, "Ambient temperature", "ºC", 1 ],
    [ 0x0010, "Remote battery temperature sensor", "ºC", 1 ],
    [ 0x0011, "Charge state", "", chargeState ],
    [ 0x0012, "Array fault", "", arrayFault ],
    [ 0x0013, "Battery voltage (slow filter, τ ≈ 25s)", "V", 100*2**-15 ],
    [ 0x0014, "Battery regulator reference voltage", "V", 96.667*2**-15 ],
    [ 0x0015, "Ah charge, resettable:HI", "Ah", 0.1 ],
    [ 0x0016, "Ah charge, resettable:LO", "Ah", 0.1 ],
    [ 0x0017, "Ah charge, total:HI", "Ah", 0.1 ],
    [ 0x0018, "Ah charge, total:LO", "Ah", 0.1 ],
    [ 0x0019, "kWh charge", "kWh", 0.1 ],
    [ 0x001a, "Load state", "", loadState ],
    [ 0x001b, "Load fault", "", loadFault ],
    [ 0x001c, "Load current compensated LVD voltage", '', 100*2**-15 ],
    [ 0x001d, "Ah load, resettable:HI", "Ah", 0.1 ],
    [ 0x001e, "Ah load, resettable:LO", "Ah", 0.1 ],
    [ 0x001f, "Ah load, total:HI", "Ah", 0.1 ],
    [ 0x0020, "Ah load, total:LO", "Ah", 0.1 ],
    [ 0x0021, "Hourmeter:HI", "h", 1 ],
    [ 0x0022, "Hourmeter:LO", "h", 1 ],
    [ 0x0023, "Alarm bitfield:HI", "", alarmBits ],
    [ 0x0024, "Alarm bitfield:LO", "", alarmBits ],
    [ 0x0025, "DIP switch", "", dipSwitch ],
    [ 0x0026, "LED state", "", 0 ],
    [ 0x0027, "Power out", "W", 989.5*2**-16 ],
    [ 0x0028, "Array Vmp found during sweep", "V", 100*2**-15 ],
    [ 0x0029, "Array Pmax(output) found during sweep", "W", 989.5*2**-16 ],
    [ 0x002a, "Array Voc found during sweep", "V", 100*2**-15 ],
    [ 0x002b, "Battery min voltage, daily", "V", 100*2**-15 ],
    [ 0x002c, "Battery max voltage, daily", "V", 100*2**-15 ],
    [ 0x002d, "Ah charge, daily", "Ah", 0.1 ],
    [ 0x002e, "Ah load, daily", "Ah", 0.1 ],
    [ 0x002f, "Array fault bitfield", "", 0 ],
    [ 0x0030, "Load fault bitfield", "", 0 ],
    [ 0x0031, "Alarm bitfield, daily:HI", "", alarmBits ],
    [ 0x0032, "Alarm bitfield, daily:LO", "", alarmBits ],
    [ 0x0033, "Min battery voltage", "V", 100*2**-15 ],
    [ 0x0034, "Max battery voltage", "V", 100*2**-15 ],
    [ 0x0038, "Lighting should be on if nonzero", "", 1 ],
    [ 0x0039, "Fixed Vmp if set (overrides % if both set)", "V", 100*2**-15 ],
    [ 0x003a, "Vmp = % of Voc if set (0 or 255 disables)", "V", 100*2**-8 ],
];

const buttons = [
    [ 0x0000, "Equalize", "button" ],
    [ 0x0001, "Load disconnect", "switch" ],
    [ 0x0002, "Charge disconnect", "switch" ],
    [ 0x0010, "Clear Ah resettable", "button" ],
    [ 0x0011, "Clear Ah total resettable", "button" ],
    [ 0x0012, "Clear kWh resettable", "button"  ],
    [ 0x0016, "Force EEPROM update", "button" ],
    [ 0x0016, "Turn on lights for 10 minutes", "button" ],
    [ 0x0009, "Reset", "button"  ]
];

export class TimeseriesCanvas extends Component {
    _canvasRef = React.createRef();

    constructor(props) {
        super(props);

        const localToday = new Date();
        today.setHours(0, 0, 0, 0);

        const macaddr = this.props.deviceId
            .split(':', 1)[0]
            .trim()
            .toLowerCase();

        this.state = {
            today: localToday,

            macaddr: macaddr,

            width: 0,
            height: 0,

            points: new Int32Array(0)
        };
    }

    componentDidMount() {
        this._fetchDate(this.state.today);
    }

    componentWillUnmount() {

    }

    componentDidUpdate() {

    }

    _fetchDate(date) {
        
    }

    _onPointerMove = (event) => {

    };

    render() {
        return <canvas
            ref={this._canvasRef}
            width={this.state.width}
            height={this.state.height}
            onPointerMove={this._onPointerMove}
            />
    }
}

export default class Solar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            messages: new Map()
        };
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    componentDidUpdate(prevProps, prevState) {

    }

    render() {
        const items = parameters.map((info, index, parameters) => {
            let [
                address,
                description,
                unit,
                scaleTable
            ] = info;

            let value;

            if (description.endsWith(':HI')) {
                description = description.slice(0, -3);
                const needle = description + ':LO';
                const lowIndex = parameters.findIndex((parameter) => {
                    return parameter[1] === needle;
                });
                const lowAddress = parameters[lowIndex][0];
                value = (debugData[address] << 16) | debugData[lowAddress];
            } else if (description.endsWith(':LO')) {
                return null;
            } else {
                value = debugData[address];
            }

            let valueDisplay;
            
            if (Array.isArray(scaleTable)) {
                // Bit table
                const rows = scaleTable.map((bitMeaning, bitNr) => {
                    const cell = bitMeaning;
                    const isSet = (value & (1 << bitNr)) !== 0;
                    return <tr>
                        <td className={isSet ? 'bit-is-set' : 'bit-not-set'}>
                            {isSet ? '1' : '0'}{' '}{bitMeaning}
                        </td>
                    </tr>;
                });
                valueDisplay = <table className="bit-table">
                    <tbody children={rows}/>
                </table>;
            } else if (scaleTable instanceof Map) {
                // Enumeration table
                valueDisplay = <span 
                    children={scaleTable.get(value)}
                    />;
            } else if (typeof scaleTable === 'number') {
                // Scale factor
                valueDisplay = <span 
                    children={(value * scaleTable).toFixed(3)}
                    />;
            }

            return <tr>
                <td className="solar-cell">
                    {description}
                </td>
                <td className="solar-cell right-cell">
                    {valueDisplay}
                </td>
                <td className="solar-cell">
                    {unit}
                </td>
            </tr>;
        }).filter((el) => el);

        const buttonEls = buttons.map((button) => {
            const [
                addr,
                message,
                kind
            ] = button;

            return kind=== 'switch' 
                ? <label>
                    <input type='checkbox'
                        checked={1}/>
                </label>
                : <button></button>;
        });

        return <div>
            <div>These are temporary placeholder values</div>

            <table className='solar-table'>
                <tbody>
                    {items}
                </tbody>
            </table>
        </div>;
    }
}

function makeDebugData() {
    return {"8":8395,"9":0,"10":8385,"11":0,"12":30,"13":34,"14":39,"15":39,"16":25,"17":3,"18":0,"19":8395,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":1,"27":0,"28":7536,"29":0,"30":0,"31":0,"32":0,"33":0,"34":1458,"35":0,"36":1,"37":8,"38":6,"39":0,"40":0,"41":0,"42":0,"43":8375,"44":8418,"45":0,"46":0,"47":0,"48":0,"49":0,"50":1,"51":6472,"52":8707,"56":0,"57":0,"58":0};
}
